import React from 'react';
import styled from 'styled-components';
import SuggestedTrainingVideo from './SuggestedTrainingVideo';
import { SingleVideo } from './types';

const Wrapper = styled.div`
  padding: 14px 26px 80px 20px;
  background: #F8F8F8;
`;

const SuggestedList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  color: #031C38;
  margin-bottom: 20px;
`;

const SuggestedTrainingVideoList = ({data = [], module}) => {
  return (
    <>
      {!!data.length && (
        <Wrapper>
          <Title>Other Videos You May Like</Title>
          <SuggestedList>
            {data.map((item: SingleVideo) => <SuggestedTrainingVideo module={module} key={item.id} itemData={item} />)}
          </SuggestedList>
        </Wrapper>
      )}
    </>
  );
};

export default SuggestedTrainingVideoList;
